import { render, staticRenderFns } from "./m-recusa.vue?vue&type=template&id=61042c16&"
import script from "./m-recusa.vue?vue&type=script&lang=js&"
export * from "./m-recusa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports